// import components
import { Tooltip } from '@mui/material';

// import types
import { DutyLineGridRow } from '../HoursTable.types';

// import utils
import dayjs from 'dayjs';
import { StyledCapitalizedBox, TooltipBox } from './TooltipCell.styles';

const TooltipCell = ({
  value,
  periods = [],
  customTooltipText
}: {
  value: string;
  periods?: DutyLineGridRow['periods'];
  customTooltipText?: string;
}) => (
  <Tooltip
    title={
      periods.length > 0
        ? (periods ?? []).map((period, index) => {
            const start = dayjs(period.startTime).format('HH:mm');
            const end = dayjs(period.endTime).format('HH:mm');
            return (
              <StyledCapitalizedBox key={index}>
                {`${start} - ${end}`} &middot;{' '}
                {` ${period.dutyHourType?.description}`}
              </StyledCapitalizedBox>
            );
          })
        : customTooltipText || value
    }
    arrow
  >
    <TooltipBox>{value}</TooltipBox>
  </Tooltip>
);

export default TooltipCell;
